import { Button, Heading, Icon, Show, Text, VStack } from '@chakra-ui/react';
import { ReactComponent as close } from 'assets/close.svg';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { ROUTES } from 'router/routes';

type OrderSummaryFailureOrCancelledViewProps = {
  paymentStatus: 'FAILURE' | 'CANCELLED';
};

export const OrderSummaryFailureOrCancelledView = ({
  paymentStatus,
}: OrderSummaryFailureOrCancelledViewProps) => {
  const isPaymentCancelled = paymentStatus === 'CANCELLED';

  return (
    <VStack bg='green.G700' textAlign='center' justifyContent='center' gap='16px' p='40px 16px'>
      <Icon as={close} boxSize='80px' color='red.G500' />
      <div>
        <Heading
          as='h1'
          variant={{ base: 'headingMedium', sm: 'headingLarge' }}
          mb='4px'
          color='white'
        >
          <FormattedMessage
            id={isPaymentCancelled ? 'orderSummary.cancelled.title' : 'orderSummary.error.title'}
            defaultMessage={
              isPaymentCancelled ? 'Payment cancelled' : 'Error during placing an order'
            }
          />
        </Heading>
        <Text textStyle='bodyLargeRegular' color='white'>
          <FormattedMessage
            id={
              isPaymentCancelled
                ? 'orderSummary.cancelled.descriptionFirstLine'
                : 'orderSummary.error.descriptionFirstLine'
            }
            defaultMessage={
              isPaymentCancelled
                ? 'This payment was cancelled, so your order was not completed.'
                : 'Unknown error happened during placing an order.'
            }
          />
        </Text>
        <Show above='md'>
          <Text textStyle='bodyLargeRegular' color='white' mt='0px'>
            <FormattedMessage
              id={
                isPaymentCancelled
                  ? 'orderSummary.cancelled.descriptionSecondLine'
                  : 'orderSummary.error.descriptionSecondLine'
              }
              defaultMessage={
                isPaymentCancelled
                  ? 'You can try again from the event page if you still want tickets.'
                  : 'Please try again later'
              }
            />
          </Text>
        </Show>
      </div>
      <Button
        variant='primaryMedium'
        bg='green.G0'
        borderColor='green.G0'
        _hover={{ bg: 'green.G200', borderColor: 'green.G200' }}
        textColor='dark.D900'
        as={Link}
        to={ROUTES.home}
      >
        <FormattedMessage id='orderSummary.error.button' defaultMessage='Back to homepage' />
      </Button>
    </VStack>
  );
};
